import React, { memo } from "react";
import ProjectSelect from "../ProjectSelect/ProjectSelect.jsx";

const ProjectSelectCellEditor = memo((params) => {
  const projectId = params.value?.id ?? params.data?.[params.colDef.field]?.id ?? params.data?.project_id ?? null;

  return (
    <ProjectSelect
      value={projectId}
      onChange={(projectId) => params.onValueChange(projectId)}
    />
  );
});

export default ProjectSelectCellEditor;